import React, { useEffect, useState, useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './ApproveOrRejectAttendace.css';
import { gettingApproveOrRejectAttendanceEmployee, updateAttendanceStatus } from '../../../services/monthlyAttendanceService';
import { format } from 'date-fns';

const ApproveOrRejectAttendace = () => {
    const [attendance, setAttendance] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isFocused, setIsFocused] = useState({
        fromDate: false,
        toDate: false,
    });
    const [loading, setLoading] = useState(false);
    const [updatingId, setUpdatingId] = useState(null);
    const yearInputRef = useRef(null);
    const employeeUniqueId = localStorage.getItem('employeeUniqueIdLogin');

    // Rejection modal state
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [selectedAttendanceId, setSelectedAttendanceId] = useState(null);
    const [rejectionError, setRejectionError] = useState('');

    const isFetchDataEnabled = fromDate && toDate;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = await gettingApproveOrRejectAttendanceEmployee(
                employeeUniqueId,
                fromDate,
                toDate
            );
            setAttendance(data);
        } catch (error) {
            console.error("Error fetching attendance:", error);
            alert("Failed to fetch attendance data");
        } finally {
            setLoading(false);
        }
    };

    const handleStatusUpdate = async (attendanceId, status, reason = '') => {
        setUpdatingId(attendanceId);
        try {
            const payload = {
                attendanceId: attendanceId,
                approverId: parseInt(employeeUniqueId),
                status: status,
                approvalRemarks: status === "APPROVED"
                    ? ""
                    : reason
            };

            await updateAttendanceStatus(payload);

            // Update the local state to reflect the change
            setAttendance(prevAttendance =>
                prevAttendance.map(item =>
                    item.attendanceId === attendanceId
                        ? { ...item, status: status }
                        : item
                )
            );

            alert(`Attendance ${status.toLowerCase()} successfully!`);
        } catch (error) {
            console.error("Error updating status:", error);
            alert(`Failed to ${status.toLowerCase()} attendance`);
        } finally {
            setUpdatingId(null);
        }
    };

    // Open rejection modal
    const handleRejectClick = (attendanceId) => {
        setSelectedAttendanceId(attendanceId);
        setRejectionReason('');
        setRejectionError('');
        setShowRejectModal(true);
    };

    // Close rejection modal
    const handleCloseRejectModal = () => {
        setShowRejectModal(false);
        setSelectedAttendanceId(null);
        setRejectionReason('');
        setRejectionError('');
    };

    // Submit rejection with reason
    const handleRejectSubmit = async (e) => {
        e.preventDefault();
        
        // Validate reason is not empty
        if (!rejectionReason.trim()) {
            setRejectionError('Please enter a rejection reason');
            return;
        }

        const attendanceId = selectedAttendanceId;
        handleCloseRejectModal();
        await handleStatusUpdate(attendanceId, 'REJECTED', rejectionReason.trim());
    };

    const handleClear = () => {
        setFromDate(null);
        setToDate(null);
        setAttendance([]);
    };

    return (
        <div className="approveorreject-contaienr">
            <div className="approveorreject-contaienr-not-in-loc-box">
                <h2 className="approveorreject-contaienr-not-in-loc-heading">
                    Approve Or Reject Attendance
                </h2>

                <form onSubmit={handleSubmit}>
                    <div className="employee-report-not-in-loc-maincontainer">
                        <div className="approveorreject-contaienr-part">
                            <div className={`approveorreject-contaienr-not-in-loc-label-container ${(isFocused.fromDate || fromDate) ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={fromDate}
                                    onChange={(date) => setFromDate(date)}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, fromDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, fromDate: false }))}
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText=""
                                    className="approveorreject-contaienr-not-in-loc-date-picker"
                                    maxDate={new Date()}
                                    ref={yearInputRef}
                                />
                                <label><span className="required">*</span>From Date</label>
                            </div>
                        </div>

                        <div className="approveorreject-contaienr-part">
                            <div className={`approveorreject-contaienr-not-in-loc-label-container ${(isFocused.toDate || toDate) ? 'float-label' : ''}`}>
                                <DatePicker
                                    selected={toDate}
                                    onChange={(date) => setToDate(date)}
                                    dateFormat='dd-MM-yyyy'
                                    className="approveorreject-contaienr-not-in-loc-date-picker"
                                    minDate={fromDate}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, toDate: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, toDate: false }))}
                                />
                                <label><span className="required">*</span>To Date</label>
                            </div>
                        </div>
                    </div>

                    <div className="employee-report-not-in-loc-maincontainer">
                        <div className="approveorreject-contaienr-part">
                            <div className="employee-report-not-in-loc-btn-div" style={{ display: 'flex', gap: '10px' }}>
                                <button 
                                    type="button"
                                    onClick={handleClear}
                                    className="employee-report-not-in-loc-btn-clear"
                                >
                                    Clear
                                </button>
                                <button
                                    type="submit"
                                    className="employee-report-not-in-loc-btn"
                                    disabled={!isFetchDataEnabled || loading}
                                >
                                    {loading ? 'Loading...' : 'Generate Report'}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

                {/* Table */}
                {attendance.length > 0 && (
                    <div className="attendance-table-container">
                        <h3 className="attendance-table-title">Attendance Records</h3>
                        <div className="table-responsive">
                            <table className="attendance-table">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Employee Name</th>
                                        <th>Employee ID</th>
                                        <th>Designation</th>
                                        <th>District</th>
                                        <th>Attendance Date</th>
                                        <th>Remarks</th>
                                        <th>Contact Number</th>
                                        <th>Audit Message</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {attendance.map((item, index) => (
                                        <tr key={item.attendanceId}>
                                            <td>{index + 1}</td>
                                            <td>{item.employeeName || '-'}</td>
                                            <td>{item.employeeId || '-'}</td>
                                            <td>{item.designation || '-'}</td>
                                            <td>{item.districtName || '-'}</td>
                                            <td>{item.attendanceDate ? format(new Date(item.attendanceDate), 'dd-MM-yyyy') : '-'}</td>
                                            <td>{item.remarks || '-'}</td>
                                            <td>{item.contactNumber || '-'}</td>
                                            <td className="audit-message">{item.auditMessage || '-'}</td>
                                            <td>
                                                <span className={`status-badge ${item.status?.toLowerCase() || 'pending'}`}>
                                                    {item.status || 'PENDING'}
                                                </span>
                                            </td>
                                            <td>
                                                {!item.status || item.status === 'PENDING' ? (
                                                    <div className="action-buttons">
                                                        <button
                                                            className="btn-approve"
                                                            onClick={() => handleStatusUpdate(item.attendanceId, 'APPROVED')}
                                                            disabled={updatingId === item.attendanceId}
                                                        >
                                                            {updatingId === item.attendanceId ? '...' : 'Approve'}
                                                        </button>
                                                        <button
                                                            className="btn-reject"
                                                            onClick={() => handleRejectClick(item.attendanceId)}
                                                            disabled={updatingId === item.attendanceId}
                                                        >
                                                            {updatingId === item.attendanceId ? '...' : 'Reject'}
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <span className="action-done">✓ Done</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            {/* Rejection Reason Modal */}
            {showRejectModal && (
                <div className="reject-modal-overlay">
                    <div className="reject-modal">
                        <div className="reject-modal-header">
                            <h3>Rejection Reason</h3>
                            <button 
                                className="reject-modal-close"
                                onClick={handleCloseRejectModal}
                                type="button"
                            >
                                &times;
                            </button>
                        </div>
                        <form onSubmit={handleRejectSubmit}>
                            <div className="reject-modal-body">
                                <label htmlFor="rejectionReason">
                                    Please enter the reason for rejection <span className="required">*</span>
                                </label>
                                <textarea
                                    id="rejectionReason"
                                    className="reject-modal-textarea"
                                    value={rejectionReason}
                                    onChange={(e) => {
                                        setRejectionReason(e.target.value);
                                        if (e.target.value.trim()) {
                                            setRejectionError('');
                                        }
                                    }}
                                    placeholder="Enter rejection reason..."
                                    rows="4"
                                    autoFocus
                                />
                                {rejectionError && (
                                    <span className="reject-modal-error">{rejectionError}</span>
                                )}
                            </div>
                            <div className="reject-modal-footer">
                                <button
                                    type="button"
                                    className="reject-modal-btn-cancel"
                                    onClick={handleCloseRejectModal}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="reject-modal-btn-submit"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ApproveOrRejectAttendace;